import 'antd/dist/antd.variable.min.css';
import './styles/global.scss';
import './i18n';

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from 'pages/Root';
import { initMobX } from 'stores/initMobx';

import { ROOT_NODE } from './config/rootNode';

initMobX();

// eslint-disable-next-line no-console
console.log('initialized...');

const root = createRoot(ROOT_NODE);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
